module.exports = __webpack_public_path__ + "img/simple-search.4fbb321.svg";